// ---------------------------------------------------------------------------
// Tutorials.
//
// A placeholder with a real route, deliberately. The button for this sits in
// the organizer header next to Reports and Voters, and a button that goes
// nowhere is worse than no button -- so the destination exists and says what
// it is going to be. Fill in the sections below; nothing else needs touching.
// ---------------------------------------------------------------------------

import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

export function TutorialsScreen() {
  const { profile } = useAuth();
  const organizing = profile?.role === 'organizer' || profile?.role === 'admin';

  return (
    <main className="page">
      <header className="page__head">
        <div>
          <h1>Tutorials</h1>
          <p className="page__sub">How to use YuCanvas</p>
        </div>
        <Link className="btn btn--link" to={organizing ? '/organize' : '/turfs'}>
          Back
        </Link>
      </header>

      <p className="empty">
        Nothing here yet. This is where the walkthroughs will live — knocking a
        turf, logging a conversation, and running the organizer dashboard.
      </p>
    </main>
  );
}
